const currentHost = window.location.hostname;

let baseurl_api;
let baseurl_photobooth;

// localhost
if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
  baseurl_api = 'https://dev.api.visideastudio.com';
  baseurl_photobooth = 'https://zeus.awh.co.id/photobooth/index.php/';
  //   baseurl_api = 'https://apicms.awh.co.id';
}

// dev environment
else if (currentHost.startsWith('dev.')) {
  baseurl_api = 'https://dev.api.visideastudio.com';
  baseurl_photobooth = 'https://dev.awh.co.id/photobooth/index.php/';
}

// production
else {
  // domain.com -> api.domain.com
  baseurl_api = `https://api.${currentHost}`;
  baseurl_photobooth = 'https://zeus.awh.co.id/photobooth/index.php/';
}


export const environment = {
  production: false,
  qris_payment_channel_id: '019e86da-b3c4-7256-bbaf-8939633358c5',
  https: 'https://',
  baseurl_api: baseurl_api,
  baseurl_photobooth: baseurl_photobooth,
  photobooth_public_key: 'cGhvdG9ib290aC5hd2guY28uaWQ=',
  photobooth_Authorization: 'fjeiwfjwuief93u829r3',
  photobooth_api_key: '9d999946-2222-4339-9a77-7d0a2c7c3e87',
  baseurlStorage: 'https://ezgate.co.id/api_dev/',
  pathImg: '',
  path: '',
  auth: '/api/v1/auth/login',
  register: 'register',
  token: '',
  refresh_token: 'auth/refresh',
  img_default:
    'https://zeus.awh.co.id/awh_pos/images/k4m3dNY7iv416BvZCtKgMsagFVlI6kHTVIpcq8TiA-AhZlmGJYgTV4PBHHTiGDk9JLzi9Lh6kfGcirloU39_xfJcfF7FsDol4NmfI-IjzLUyerd7uXyZkaFuaEYGbITi',
  mqtt: {
    username: 'dhivapos',
    password: 'FurlaRasaMelon2024',
  },
};

